import { render } from "./AltaTktCmp.vue?vue&type=template&id=87a81004"
import script from "./AltaTktCmp.vue?vue&type=script&lang=js"
export * from "./AltaTktCmp.vue?vue&type=script&lang=js"

import "./AltaTktCmp.vue?vue&type=style&index=0&id=87a81004&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__